// src/services/api.js
/**
 * Centralized Axios instance for all API calls.
 * Re-exports from auth/api.js for backward compatibility.
 * This is the canonical import location for the api instance.
 */

import api from '../auth/api';

export default api;
